<!--党建引领-->
<template>
    <div class="studio_nav_content">
        <div class="content-container1" v-show="showMode==='page'">
            <!-- 理论思想 -->
            <div class="title-container">
                <a class="a-link">理论思想</a>
            </div>
            <div class="list-item-container">
                <div class="item-dashboard1">
                    <div class="item-title"><div class="share-title" @click="pageDangJian('理论思想','学习园地','5')"><a>学习园地</a></div></div>
                    <div class="item-list">
                        <div class="dj-item" v-for="item in homeData.xxydList" :key="item.dangjId">
                            <div class="dj-item-l"><div class="dj-yuan"></div></div>
                            <div class="dj-item-r" @click="viewDangj(item)">{{item.title}}</div>
                        </div>
                    </div>
                    <div class="div-100" v-if="homeData.xxydList&&homeData.xxydList.length===0">
                        <dataEmpty title="暂无数据" />
                    </div>
                </div>
                <div class="item-dashboard1">
                    <div class="item-title"><div class="share-title" @click="pageDangJian('理论思想','理论强党','6')"><a>理论强党</a></div></div>
                    <div class="item-list">
                        <div class="dj-item" v-for="item in homeData.llqdList" :key="item.dangjId">
                            <div class="dj-item-l"><div class="dj-yuan"></div></div>
                            <div class="dj-item-r" @click="viewDangj(item)">{{item.title}}</div>
                        </div>
                    </div>
                    <div class="div-100" v-if="homeData.llqdList&&homeData.llqdList.length===0">
                        <dataEmpty title="暂无数据" />
                    </div>
                </div>
                <div class="item-dashboard2">
                    <div class="item-title"><div class="share-title" @click="pageDangJian('理论思想','党建论坛','7')"><a>党建论坛</a></div></div>
                    <div class="item-list">
                        <div class="dj-item" v-for="item in homeData.djltList" :key="item.dangjId">
                            <div class="dj-item-l"><div class="dj-yuan"></div></div>
                            <div class="dj-item-r" @click="viewDangj(item)">{{item.title}}</div>
                        </div>
                    </div>
                    <div class="div-100" v-if="homeData.djltList&&homeData.djltList.length===0">
                        <dataEmpty title="暂无数据" />
                    </div>
                </div>
            </div>
            <!-- 宣传思想文化工作 -->
            <div class="title-container">
                <a class="a-link">宣传思想文化工作</a>
            </div>
            <div class="list-item-container">
                <div class="item-dashboard1">
                    <div class="item-title"><div class="share-title" @click="pageDangJian('宣传思想文化工作','工作动态','8')"><a>工作动态</a></div></div>
                    <div class="item-list">
                        <div class="dj-item" v-for="item in homeData.gzdtList" :key="item.dangjId">
                            <div class="dj-item-l"><div class="dj-yuan"></div></div>
                            <div class="dj-item-r" @click="viewDangj(item)">{{item.title}}</div>
                        </div>
                    </div>
                    <div class="div-100" v-if="homeData.gzdtList&&homeData.gzdtList.length===0">
                        <dataEmpty title="暂无数据" />
                    </div>
                </div>
                <div class="item-dashboard1">
                    <div class="item-title"><div class="share-title" @click="pageDangJian('宣传思想文化工作','经验交流','9')"><a>经验交流</a></div></div>
                    <div class="item-list">
                        <div class="dj-item" v-for="item in homeData.jyjlList" :key="item.dangjId">
                            <div class="dj-item-l"><div class="dj-yuan"></div></div>
                            <div class="dj-item-r" @click="viewDangj(item)">{{item.title}}</div>
                        </div>
                    </div>
                    <div class="div-100" v-if="homeData.jyjlList&&homeData.jyjlList.length===0">
                        <dataEmpty title="暂无数据" />
                    </div>
                </div>
                <div class="item-dashboard2">
                    <div class="item-title"><div class="share-title" @click="pageDangJian('宣传思想文化工作','文明实践','10')"><a>文明实践</a></div></div>
                    <div class="item-list">
                        <div class="dj-item" v-for="item in homeData.wmsjList" :key="item.dangjId">
                            <div class="dj-item-l"><div class="dj-yuan"></div></div>
                            <div class="dj-item-r" @click="viewDangj(item)">{{item.title}}</div>
                        </div>
                    </div>
                    <div class="div-100" v-if="homeData.wmsjList&&homeData.wmsjList.length===0">
                        <dataEmpty title="暂无数据" />
                    </div>
                </div>
            </div>
            <!-- 党建工作 -->
            <div class="title-container">
                <a class="a-link">党建工作</a>
            </div>
            <div class="list-item-container">
                <div class="item-dashboard1">
                    <div class="item-title"><div class="share-title" @click="pageDangJian('党建工作','基层党建','11')"><a>基层党建</a></div></div>
                    <div class="item-list">
                        <div class="dj-item" v-for="item in homeData.jcdjList" :key="item.dangjId">
                            <div class="dj-item-l"><div class="dj-yuan"></div></div>
                            <div class="dj-item-r" @click="viewDangj(item)">{{item.title}}</div>
                        </div>
                    </div>
                    <div class="div-100" v-if="homeData.jcdjList&&homeData.jcdjList.length===0">
                        <dataEmpty title="暂无数据" />
                    </div>
                </div>
                <div class="item-dashboard1">
                    <div class="item-title"><div class="share-title" @click="pageDangJian('党建工作','机关党建','12')"><a>机关党建</a></div></div>
                    <div class="item-list">
                        <div class="dj-item" v-for="item in homeData.jgdjList" :key="item.dangjId">
                            <div class="dj-item-l"><div class="dj-yuan"></div></div>
                            <div class="dj-item-r" @click="viewDangj(item)">{{item.title}}</div>
                        </div>
                    </div>
                    <div class="div-100" v-if="homeData.jgdjList&&homeData.jgdjList.length===0">
                        <dataEmpty title="暂无数据" />
                    </div>
                </div>
                <div class="item-dashboard2">
                    <div class="item-title"><div class="share-title" @click="pageDangJian('党建工作','校园党建','13')"><a>校园党建</a></div></div>
                    <div class="item-list">
                        <div class="dj-item" v-for="item in homeData.xydjList" :key="item.dangjId">
                            <div class="dj-item-l"><div class="dj-yuan"></div></div>
                            <div class="dj-item-r" @click="viewDangj(item)">{{item.title}}</div>
                        </div>
                    </div>
                    <div class="div-100" v-if="homeData.xydjList&&homeData.xydjList.length===0">
                        <dataEmpty title="暂无数据" />
                    </div>
                </div>
            </div>
            <!-- 党史·文化 -->
            <div class="title-container">
                <a class="a-link">党史·文化</a>
            </div>
            <div class="list-item-container">
                <div class="item-dashboard1">
                    <div class="item-title"><div class="share-title" @click="pageDangJian('党史·文化','学史明理','14')"><a>学史明理</a></div></div>
                    <div class="item-list">
                        <div class="dj-item" v-for="item in homeData.xsmlList" :key="item.dangjId">
                            <div class="dj-item-l"><div class="dj-yuan"></div></div>
                            <div class="dj-item-r" @click="viewDangj(item)">{{item.title}}</div>
                        </div>
                    </div>
                    <div class="div-100" v-if="homeData.xsmlList&&homeData.xsmlList.length===0">
                        <dataEmpty title="暂无数据" />
                    </div>
                </div>
                <div class="item-dashboard1">
                    <div class="item-title"><div class="share-title" @click="pageDangJian('党史·文化','经典常读','15')"><a>经典常读</a></div></div>
                    <div class="item-list">
                        <div class="dj-item" v-for="item in homeData.jdcdList" :key="item.dangjId">
                            <div class="dj-item-l"><div class="dj-yuan"></div></div>
                            <div class="dj-item-r" @click="viewDangj(item)">{{item.title}}</div>
                        </div>
                    </div>
                    <div class="div-100" v-if="homeData.jdcdList&&homeData.jdcdList.length===0">
                        <dataEmpty title="暂无数据" />
                    </div>
                </div>
                <div class="item-dashboard2">
                    <div class="item-title"><div class="share-title" @click="pageDangJian('党史·文化','文化大观','16')"><a>文化大观</a></div></div>
                    <div class="item-list">
                        <div class="dj-item" v-for="item in homeData.whdgList" :key="item.dangjId">
                            <div class="dj-item-l"><div class="dj-yuan"></div></div>
                            <div class="dj-item-r" @click="viewDangj(item)">{{item.title}}</div>
                        </div>
                    </div>
                    <div class="div-100" v-if="homeData.whdgList&&homeData.whdgList.length===0">
                        <dataEmpty title="暂无数据" />
                    </div>
                </div>
            </div>
        </div>

        <div class="content-container" v-show="showMode==='detail'">
            <page-dangj :info-mode="infoMode" :title="title" :sub-title="subTitle" :dj-type="subcategory"
                        @change-mode="changeModel" />
        </div>

        <!--详情模式-->
        <div class="detail-mode" v-if="showMode==='detailInfo'">
            <div class="dj-container">
                <div class="dj-title">{{ form.title }}</div>
                <div class="dj-time">发布时间：{{ timestampToTime(form.releaseTime) }}</div>
                <div class="dj-content" v-html="form.content">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import dataEmpty from "@/components/dataEmpty.vue";
import pageDangj from "@/components/resourceCentre/pageDangj.vue";
import {timestampDate, timestampToTime} from "@/utils/date";
import {homeDangj, infoDangj} from "@/api/admin/dangj"

export default {
    name:'djylResource',
    components:{dataEmpty,pageDangj},
    props:{
        courseMode:{
            type: String,
            default:'page',
        },
    },
    watch:{
        courseMode(newValue,oldValue){
            this.showMode = newValue;
        },
    },
    mounted() {
    },
    created() {
        this.queryHomeData();
    },
    data() {
        return {
            showMode:'page',
            timestampDate,
            homeData:{},
            title:'',
            subTitle:'',
            subcategory:'',
            infoMode:"pageSub",
            dangjId:'',
            form:{},  //数据
            timestampToTime,
        }
    },
    methods: {
        queryHomeData(){
            homeDangj().then(res=>{
                if (res.data.code === 1) {
                    this.homeData = res.data.data;
                } else {
                    this.$message.error("请求出错");
                }
            })
        },
        pageDangJian(v1,v2,v3){
            this.title = v1;
            this.subTitle = v2;
            this.subcategory = v3;
            this.showMode = 'detail';
            this.infoMode = this.infoMode+new Date();
            this.$emit('change-mode',this.showMode);
        },
        changeModel(item){
            this.showMode = item
            this.$emit('change-mode',this.showMode);
        },
        viewDangj(item){
            this.dangjId = item.dangjId;
            this.getDangjInfo();
            this.showMode = "detailInfo"
            this.$emit('change-mode',this.showMode);
        },
        getDangjInfo(){
            infoDangj({ dangjId: this.dangjId }).then(res => {
                if (res.data.code === 1) {
                    this.form = res.data.data;
                }else {
                    this.$message.error("操作失败")
                }
            })
        },
    }
}

</script>

<style scoped>
.studio_nav_content{
    width: 100%;
    height: auto;
    background-color: #fff;
}
.content-container1{
    width: 100%;
    margin: auto;
    height: auto;
    padding-left: 10px;
    box-sizing: border-box;
}
.content-container{
    width: 100%;
    margin: auto;
    height: calc(100vh - 90px);
}
.title-container{
    border-bottom: 1px solid #ff7f2e;
    display: block;
    unicode-bidi: isolate;
    padding-top: 10px;
    margin-bottom: 10px;
}
.a-link{
    font-size: 18px;
    display: inline-block;
    color: #ff7f2e;
    font-weight: bold;
    border-bottom: 2px solid #ff7f2e;
    padding-bottom: 0.1rem;
    text-decoration: none;
}

.list-item-container{
    width: 100%;
    height: auto;
    display: flex;
}
.item-dashboard1{
    width: 32.66%;
    height: auto;
    margin-right: 1%;
    background-color: #fff;

}
.item-dashboard2{
    width: 32.66%;
    height: auto;
    background-color: #fff;
}
.item-title{
    border-bottom: 0.01rem solid #dedede;
}
.share-title{

}
.share-title a {
    font-size: 16px;
    display: inline-block;
    color: #222222;
    font-weight: bold;
    border-bottom: 2px solid #ff7f2e;
    padding-bottom: 0.1rem;
    text-decoration: none;
    cursor: pointer;
}


.item-list{
    width: 100%;
    height: auto;
}
.dj-item{
    width: 100%;
    height: 44px;
    display: flex;
    margin-top: 10px;
}
.dj-item-l{
    width: 10px;
    height: 44px;
}
.dj-yuan{
    width: 6px;
    height: 6px;
    border-radius: 3px;
    background-color: #ff7f2e;
    margin-top: 8px;
}
.dj-item-r{
    width: calc(100% - 10px);
    height: 44px;
    color: #595758;
    cursor: pointer;
    font-size: 14px;
    line-height: 22px;
}

.dj-container{
    width: 100%;
    height: auto;
    background-color: #fff;
}
.dj-title{
    height: 45px;
    width: 98%;
    margin: auto;
    line-height: 40px;
    font-size: 18px;
    font-weight: bold;
    text-align: center;
    border-bottom: 1px solid #DDD;
}
.dj-time{
    height: 40px;
    width: 98%;
    margin: auto;
    line-height: 40px;
    font-size: 15px;
    color: #666666;
}
.dj-content{
    width: 96%;
    margin: auto;
    overflow-x: hidden;
}
</style>